import { ReactNode } from 'react'

import { webAppState } from '@/appState'

import { ErrorFallback } from './ErrorFallback'

export const ErrorHandler = ({ children }: { children: ReactNode }) => {
    if (webAppState.SentryErrorBoundaryComponent) {
        const ErrorBoundary = webAppState.SentryErrorBoundaryComponent
        return <ErrorBoundary fallback={ErrorFallback}>{children}</ErrorBoundary>
    }

    if (webAppState.ReactErrorBoundaryComponent) {
        const ErrorBoundary = webAppState.ReactErrorBoundaryComponent
        return <ErrorBoundary fallbackRender={({ error }) => <ErrorFallback error={error} />}>{children}</ErrorBoundary>
    }

    return children
}
